export default __webpack_public_path__ + "Connect logo.svg";